// client/src/pages/sections/groups/ToastViewport.js
// Fixed-position toast stack. Mount once near the top of the section;
// renders whatever the toast bus has live.

import { dismissToast, useToasts } from './toast';

const KIND_STYLES = {
  error:   { background: '#b3261e', color: '#fff' },
  success: { background: '#0a7a3b', color: '#fff' },
  warn:    { background: '#8a5a00', color: '#fff' },
  info:    { background: '#063941', color: '#fff' },
};

export default function ToastViewport() {
  const toasts = useToasts();
  if (toasts.length === 0) return null;
  return (
    <div
      style={{
        position: 'fixed',
        right:    16,
        bottom:   16,
        display:  'flex',
        flexDirection: 'column',
        gap:      8,
        zIndex:   20000,
        maxWidth: 420,
      }}
      role="region"
      aria-label="Notifications"
    >
      {toasts.map(t => {
        const base = KIND_STYLES[t.kind] || KIND_STYLES.info;
        return (
          <div
            key={t.id}
            role={t.kind === 'error' ? 'alert' : 'status'}
            style={{
              ...base,
              padding:      '10px 14px',
              borderRadius: 6,
              boxShadow:    '0 6px 18px rgba(0,0,0,0.18)',
              display:      'flex',
              alignItems:   'flex-start',
              gap:          12,
              fontSize:     13,
              lineHeight:   1.4,
            }}
          >
            <span style={{ flex: 1 }}>{t.message}</span>
            <button
              type="button"
              onClick={() => dismissToast(t.id)}
              aria-label="Dismiss"
              style={{
                background: 'transparent',
                border:     0,
                color:      'inherit',
                cursor:     'pointer',
                fontSize:   16,
                lineHeight: 1,
                padding:    0,
              }}
            >×</button>
          </div>
        );
      })}
    </div>
  );
}
